import React from 'react';
import PageTop from '../../../core/components/PageTop';
import { PageTopBreadcrumb } from '../../../core/components/types';
import { SPLIT_ORDER_INVOICES_ROUTE_LIST } from '../split_order_invoices_const';
import { useSplitOrderInvoicesDetailsInit } from './useSplitOrderInvoicesDetailsInit';
import Panel from '../../../core/components/Panel';
import SplitOrderInvoiceLineItemsTableList from './SplitOrderInvoiceLineItemsTableList';
import SplitOrderInvoiceInformationPanel from './SplitOrderInvoiceInformationPanel';
import { useSplitOrderInvoicesDetailModel } from './useSplitOrderInvoicesDetailData';
import { useAtomValue } from 'jotai';
import { splitOrderInvoicesDetailPageStateAtom } from './split_order_invoices_detail_atoms';

const PageSplitOrderInvoicesDetails = (): JSX.Element => {
    const { title } = useSplitOrderInvoicesDetailsInit();
    const breadcrumb: PageTopBreadcrumb = {
        title: 'Return to Split Order Invoices List',
        icon: 'sprite-orders-split',
        route: SPLIT_ORDER_INVOICES_ROUTE_LIST,
    };

    return (
        <>
            <PageTop
                title={title}
                icon="sprite-orders-split"
                breadcrumb={breadcrumb}
            />
            <div className="split-order-invoices-feature split-order-invoices-details">
                <Content />
            </div>
        </>
    );
};

const Content = (): JSX.Element => {
    const invoice = useSplitOrderInvoicesDetailModel();
    const { userAffList } = useAtomValue(splitOrderInvoicesDetailPageStateAtom);

    return (
        <>
            <SplitOrderInvoiceInformationPanel
                invoice={invoice}
                userAffList={userAffList}
            />
            <Panel>
                <SplitOrderInvoiceLineItemsTableList />
            </Panel>
        </>
    );
};

export default PageSplitOrderInvoicesDetails;
